import { useTranslation } from 'react-i18next';
import Team from '#app/assets/images/team.jpg';

export default function Story() {
	const { t } = useTranslation();

	return (
		<section className="relative">
			{/* Blurred shape */}
			<div
				className="pointer-events-none absolute left-1/2 top-0 -z-10 -mt-32 ml-10 -translate-x-1/2 opacity-70 blur-2xl"
				aria-hidden="true"
			>
				<svg xmlns="http://www.w3.org/2000/svg" width="434" height="427">
					<defs>
						<linearGradient
							id="bs4-a"
							x1="19.609%"
							x2="50%"
							y1="14.544%"
							y2="100%"
						>
							<stop offset="0%" stopColor="#38B2AC"></stop>
							<stop offset="100%" stopColor="#81E6D9" stopOpacity="0"></stop>
						</linearGradient>
					</defs>
					<path
						fill="url(#bs4-a)"
						fillRule="evenodd"
						d="m0 0 461 369-284 58z"
						transform="matrix(1 0 0 -1 0 427)"
					></path>
				</svg>
			</div>

			<div className="mt-16 px-4 sm:px-6">
				<div className="mx-auto max-w-5xl">
					<div className="pb-12 md:pb-20">
						{/* Section header */}
						<div className="mx-auto max-w-3xl pb-12 text-center md:pb-20">
							<h2 className="h2 bg-gradient-to-r from-slate-200/60 via-slate-200 to-slate-200/60 bg-clip-text text-transparent">
								{t('story.sectionTitle')}
							</h2>
						</div>

						<div className="justify-between space-x-6 md:flex md:space-x-8 lg:space-x-14">
							<figure className="min-w-[240px]">
								<img
									className="sticky top-8 mx-auto mb-12 -rotate-[4deg] rounded-lg md:mb-0"
									src={Team}
									width={420}
									height={280}
									alt={t('story.teamImageAlt')}
								/>
							</figure>
							<div className="mx-auto max-w-[548px]">
								<div className="space-y-6 text-slate-400">
									<p>{t('story.paragraph1')}</p>
									<p>{t('story.paragraph2')}</p>
									<p>{t('story.paragraph3')}</p>
									<p>{t('story.paragraph4')}</p>
									<p>{t('story.paragraph5')}</p>
									<p>{t('story.paragraph6')}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
